import { render, staticRenderFns } from "./PayInformation.vue?vue&type=template&id=12be0c7c&"
import script from "./PayInformation.vue?vue&type=script&lang=js&"
export * from "./PayInformation.vue?vue&type=script&lang=js&"
import style0 from "./PayInformation.vue?vue&type=style&index=0&id=12be0c7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports